import React from 'react';
import { UserIcon, PencilIcon, TrashIcon, PlusIcon } from '@heroicons/react/24/outline';

/**
 * SpeakersList Component
 * 
 * Display list of all speakers in transcript with management options
 */
const SpeakersList = ({ 
  speakers, 
  onSelectSpeaker, 
  onAddSpeaker,
  onRenameSpeaker,
  onDeleteSpeaker,
  className = '' 
}) => {
  /**
   * Get speaker color
   */
  const getSpeakerColor = (speaker) => {
    const colors = [
      'bg-blue-100 text-blue-800 border-blue-200',
      'bg-green-100 text-green-800 border-green-200',
      'bg-purple-100 text-purple-800 border-purple-200',
      'bg-orange-100 text-orange-800 border-orange-200',
      'bg-pink-100 text-pink-800 border-pink-200',
      'bg-indigo-100 text-indigo-800 border-indigo-200',
      'bg-yellow-100 text-yellow-800 border-yellow-200',
      'bg-red-100 text-red-800 border-red-200',
    ];

    const hash = speaker.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return colors[hash % colors.length];
  };

  return (
    <div className={`space-y-3 ${className}`}>
      {/* Header with Add Button */}
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wider flex items-center gap-2">
          <UserIcon className="h-4 w-4" />
          Speakers ({speakers.length})
        </h3>
        {onAddSpeaker && (
          <button
            onClick={onAddSpeaker}
            className="p-1.5 text-xs bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors flex items-center gap-1"
            title="Add new speaker"
          >
            <PlusIcon className="h-3.5 w-3.5" />
            <span>Add</span>
          </button>
        )}
      </div>

      {/* Speaker List */}
      <div className="space-y-2">
        {speakers.length === 0 ? (
          <p className="text-sm text-gray-500">No speakers found</p>
        ) : (
          speakers.map((speaker) => (
            <div
              key={speaker.name}
              className={`
                flex items-start gap-1.5 px-3 py-2 rounded-lg border
                transition-all
                ${getSpeakerColor(speaker.name)}
              `}
            >
              {/* Speaker Button */}
              <button
                onClick={() => onSelectSpeaker?.(speaker.name)}
                className="flex-1 flex items-start justify-between gap-2 hover:opacity-80 transition-opacity text-left min-w-0"
              >
                <span className="font-medium text-sm break-words hyphens-auto">{speaker.name}</span>
                <span className="text-xs font-semibold flex-shrink-0">
                  {speaker.count}
                </span>
              </button>

              {/* Action Buttons */}
              <div className="flex items-center gap-0.5">
                {onRenameSpeaker && (
                  <button
                    onClick={() => onRenameSpeaker(speaker.name)}
                    className="p-1 hover:bg-white/50 rounded transition-colors"
                    title="Rename speaker"
                  >
                    <PencilIcon className="h-3.5 w-3.5" />
                  </button>
                )}
                {onDeleteSpeaker && (
                  <button
                    onClick={() => onDeleteSpeaker(speaker.name)}
                    className="p-1 hover:bg-red-200 rounded transition-colors"
                    title="Delete & merge speaker"
                  >
                    <TrashIcon className="h-3.5 w-3.5" />
                  </button>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SpeakersList;


